export const XR_LOCOMOTION_DEAD_ZONE = 0.14;
export const XR_ROTATION_SPEED = 1.6;
export const XR_VERTICAL_SPEED_SCALE = 0.65;
export const XR_TRANSLATION_SPEED = 2;
export const XR_MAX_ROTATION_SPEED = 2;
export const XR_MAX_FRAME_DELTA = 0.05;
export const XR_MAX_TRAVEL_BOOST = 10;
export const XR_MIN_TRAVEL_MULTIPLIER = 0.25;
/** The idle left-stick axis must exceed the locked one by this factor to take over, preventing flicker near diagonals. */
export const XR_LEFT_AXIS_SWITCH_RATIO = 1.5;
export const XR_TRAVEL_LOOK_AHEAD_SECONDS = 3;
export const XR_TRAVEL_CORRIDOR_SLOPE = 0.12;
export const XR_TRAVEL_ACCELERATION_SECONDS = 0.7;
export const XR_TRAVEL_BRAKING_SECONDS = 0.15;
export const XR_TRAVEL_EMPTY_ACCELERATION_SECONDS = 1.5;
export const XR_TRAVEL_GEOMETRY_REFRESH_SECONDS = 0.1;
/** A press held this long becomes a hold; shorter presses are taps, so a tap never starts a hold gesture. */
export const XR_BUTTON_HOLD_SECONDS = 0.25;
export const XR_NOTICE_SECONDS = 2;
